import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { CmpImage } from 'app/core/cms/generated/api-types'
import { PictureComponent } from 'app/shared/picture/picture.component'

import { CmsBlock } from '../../cms-block'
import { LayoutContainer } from '../../sections/layout-container'

@Component({
  selector: 'pai-cmp-image',
  templateUrl: './cmp-image.component.html',
  styleUrls: ['./cmp-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PictureComponent],
  providers: [{ provide: CmsBlock, useExisting: CmpImageComponent }],
})
export class CmpImageComponent extends CmsBlock<CmpImage> {
  readonly __typename = 'CmpImage'
  protected readonly parentLayout = inject(LayoutContainer).containerInfo
}
